module.exports = __webpack_public_path__ + "static/media/mahdi.1c174f49.jpg";